import './App.css';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
// import { BASE_URL } from './_globalConstants.js';

export default function AdminLogin({ loginInfo, setLoginInfo }) {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [loggingIn, setLoggingIn] = useState(false);
    const navigate = useNavigate();

    const loginResponse = async () => {
        try {
            setLoggingIn(true);

            // Format the username as a phone number
            let formattedPhoneNumber = username ? username.toString().replace(/[^0-9]/g, "") : "";
            // Add dashes to the phone number
            if (formattedPhoneNumber.length === 10) {
                formattedPhoneNumber = `${formattedPhoneNumber.slice(0, 3)}-${formattedPhoneNumber.slice(3, 6)}-${formattedPhoneNumber.slice(6)}`;
            }
            if (!formattedPhoneNumber || !/^\d{3}-\d{3}-\d{4}$/.test(formattedPhoneNumber)) {
                throw new Error("Invalid phone number format. Please enter a valid 10-digit phone number.");
            }

            const response = await fetch(`/api/login`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    username: formattedPhoneNumber,
                    password: password
                }),
            });
            if (response.ok) {
                const session = await fetch(`/api/session/info`);
                if (session.ok) {
                    const sessionData = await session.json();
                    const user = await fetch(`/api/user/${sessionData.user_id}`);
                    // console.log('userdat ', user);
                    const userSession = await user.json();
                    // console.log('userjson', userSession);
                    setLoginInfo({
                        loggedIn: true,
                    });
                }
                // setLoginInfo({
                //     token: data.token,
                //     isAdmin: data.is_admin,
                // });
                navigate('/admin');
            } else {
                console.error('Login failed:', response);
                setErrorMessage('Invalid username or password.');
                document.getElementById('error-message').style.display = 'block';
            }
        } catch (error) {
            console.error('Error during login:', error);
            setErrorMessage('An error occurred. Please try again later.');
            document.getElementById('error-message').style.display = 'block';
        }
        setLoggingIn(false);
    }

    return (
        <div>
            <style>{`
                    .page-container {
                        font-family: Arial, sans-serif;
                        background-color: #f4f4f4;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        height: 100vh;
                        margin: 0;
                    }
                    .login-container {
                        background-color: white;
                        padding: 40px;
                        box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
                        border-radius: 8px;
                        width: 300px;
                    }
                    .login-container h2 {
                        text-align: center;
                        margin-bottom: 20px;
                    }
                    .input-field {
                        width: 100%;
                        padding: 10px;
                        margin: 10px 0;
                        border: 1px solid #ddd;
                        border-radius: 4px;
                    }
                    .btn {
                        width: 100%;
                        padding: 10px;
                        background-color: #2a5ba5ff;
                        color: white;
                        border: none;
                        border-radius: 4px;
                        cursor: pointer;
                    }
                    .btn:hover {
                        background-color: #2b54a0ff;
                    }
                    .error-message {
                        color: red;
                        font-size: 14px;
                        display: none;
                    }
                `}</style>

            <div className="page-container">
                <div className="login-container">
                    <h2>Admin Login</h2>
                    <form id="adminLoginForm"
                        onSubmit={(e) => {
                            e.preventDefault();
                            loginResponse();
                        }}>
                        <input type="text"
                            id="username"
                            className="input-field"
                            placeholder="Username"
                            required
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            onKeyDown={(e) => {
                                // If clicking enter, move focus to password field
                                if (e.key === 'Enter') {
                                    e.preventDefault();
                                    document.getElementById('password').focus();
                                }
                            }}>
                        </input>
                        <input type="password"
                            id="password"
                            className="input-field"
                            placeholder="Password"
                            required
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            onKeyDown={(e) => {
                                // If clicking enter, submit the form
                                if (e.key === 'Enter') {
                                    e.preventDefault();
                                    loginResponse();
                                }
                            }}>
                        </input>
                        <button type="submit" className="btn" disabled={loggingIn}>
                            {loggingIn ? "Logging in..." : "Login"}
                        </button>
                        <p id="error-message" className="error-message">
                            {errorMessage}
                        </p>
                    </form>
                </div>
            </div>
        </div>
    );
}